import requests from '@/utils/requests';

/**
 * 流水线列表接口
 * @param {*} data
 */
export function pipelineList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/list',
    method: 'post',
    data
  });
}

/**
 * 流水线模板列表接口
 * @param {*} data
 */
export function pipelineTemplateList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/templateList',
    method: 'post',
    data
  });
}

/**
 * 添加流水线接口
 * @param {*} data
 */
export function pipelineAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/add',
    method: 'post',
    data
  });
}

/**
 * 修改流水线接口
 * @param {*} data
 */
export function pipelineModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/modify',
    method: 'post',
    data
  });
}

/**
 * 流水线详情接口
 * @param {*} data
 */
export function pipelineDetail (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/detail',
    method: 'post',
    data
  });
}

/**
 * 删除流水线接口
 * @param {*} data
 */
export function pipelineDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/delete',
    method: 'post',
    data
  });
}

/**
 * 流水线构建接口
 * @param {*} data
 */
export function pipelineBuild (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/build',
    method: 'post',
    data
  });
}

/**
 * 流水线构建历史接口
 * @param {*} data
 */
export function pipelineRecordList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/recordList',
    method: 'post',
    data
  });
}

/**
 * 流水线构建详情接口
 * @param {*} data
 */
export function pipelineRecordDetail (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/recordDetail',
    method: 'post',
    data
  });
}

/**
 * 流水线构建日志接口
 * @param {*} data
 */
export function pipelineRecordLog (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/pipeline/recordLog',
    method: 'post',
    data
  });
}
